module.exports = __webpack_public_path__ + "static/bizqr-0b984aeb076772a6d06c407e61e74471.png";